import { render, staticRenderFns } from "./TMenuOptionItem.vue?vue&type=template&id=5efe72d8&scoped=true&"
import script from "./TMenuOptionItem.vue?vue&type=script&lang=js&"
export * from "./TMenuOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./TMenuOptionItem.vue?vue&type=style&index=0&id=5efe72d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe72d8",
  null
  
)

export default component.exports